import { FormBuilder, FormGroup, Validators } from "@angular/forms";

export class ApplicationEquipmentDescription {

    form: FormGroup;

    constructor(private formBuilder: FormBuilder) {
        this.form = this.formBuilder.group({
            merchantID: ['', Validators.required],
            term: ['', [Validators.required, Validators.min(24), Validators.max(60)]],
            monthlyLeaseCharge: ['', Validators.required]
        });
    }

    decode(data: any) {
        this.form.controls.merchantID.setValue(data.merchantID);
        this.form.controls.term.setValue(data.term);
        this.form.controls.monthlyLeaseCharge.setValue(data.monthlyLeaseCharge);
    }

    encode(): any {
        return {
            'merchantID': this.form.controls.merchantID.value,
            'term': this.form.controls.term.value,
            'monthlyLeaseCharge': this.form.controls.monthlyLeaseCharge.value
        };
    }

    setDefaultData() {
        this.decode({
            merchantID: 1,
            term: 24,
            monthlyLeaseCharge: 15000
        });
    }

    get monthlyLeaseCharge() {
        return this.form.controls.monthlyLeaseCharge.value;
    }

    get term() {
        return this.form.controls.term.value;
    }
}
